export default [
  {
    path: '/chooseFinanceReportSetting',
    name: 'ChooseFinanceReportSetting',
    component: () => import('@/views/system/financeReportSetting/ChooseFinanceReportSetting.vue'),
    meta: {},
  },
];
